import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import lodash, { set } from 'lodash';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import { isMobile } from 'react-device-detect';


export const getMyInvoices = createAsyncThunk('selfCareInvoiceBlock/getMyInvoices', async (data,thunkAPI) => {
  try {

    const providerData = await ProviderManager.getProviderData('invoiceData', {});
    let res = providerData?.Body;

    if (res.invoices.length > 1) {
      res.invoices = res.invoices.filter(invoice => invoice.invoices.length > 0);
    }

    let hasInvoices = false;
    hasInvoices = res.invoices.some(item => item.invoices && item.invoices?.length > 0);

    var currentWorld = thunkAPI.getState().selfcarePage.epiData.worldType;
    if (currentWorld === TAB_ENUM.Energy) {
      var selectedSubscriber = thunkAPI.getState().selfcarePage.selectedSubscriber;
      if (selectedSubscriber.ban) {
        res.invoices = res.invoices.filter(x => x.banPsId == selectedSubscriber.ban);
      }
      res.invoices = res.invoices.filter(x => x.invoices?.length > 0 && x.invoices[0]?.description === "חשמל");
      if (res.invoices.length > 0) {
        thunkAPI.dispatch(goToPage('singleInvoice'));
      } else {
        thunkAPI.dispatch(goToPage('noInvoicesOldCustomer'));
      }
    }

    let isNewCustomer = false;
    let billCycle = '';
    if (!hasInvoices) {

      const newCustomerItem = res.invoices?.invoicesList?.find(item => item.isNewCustomer);
      isNewCustomer = newCustomerItem?.isNewCustomer;
      billCycle = newCustomerItem ? newCustomerItem.billCycle : '';
      thunkAPI.dispatch(setInvoiceData({ billCycle: billCycle }));


      if (isNewCustomer) {
        thunkAPI.dispatch(goToPage('noInvoicesNewCustomer'));
      }
      else {
        thunkAPI.dispatch(goToPage('noInvoicesOldCustomer'));
      }
    }
    if (res.invoices.length == 1 && hasInvoices) {
      thunkAPI.dispatch(goToPage('singleInvoice'));
    }
    else if(res.invoices.length > 1){
      thunkAPI.dispatch(goToPage('carouselInvoices'));
    }
    return { invoices: res.invoices, error: false };

  } catch (error) {
    thunkAPI.dispatch(goToPage('displayInvoicesError'));
    return { invoices: [], error: true };
  }
});


export const prepareBlockAsync = createAsyncThunk('selfCareInvoiceBlock/prepareBlockAsync', async (data, thunkAPI) => {
  try {
    const LoginType = {
      Full: 'full',
      Otp: 'otp',
      ExtendedOtp: 'extendedOtp',
      ContactExtendedOtp : 'contactExtendedOtp'
    };

    const authentication = thunkAPI.getState().authentication;
    const { isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated } = authentication.loginData;

    let loginType = '';

    if (isFullAuthenticated) {
      loginType = LoginType.Full;
    } else if (isOtpAuthenticated) {
      loginType = LoginType.Otp;
    } else if (isOtpExtendedAuthenticated) {
      if( authentication.loginData?.userDetails?.role &  128){
        loginType = LoginType.ContactExtendedOtp;
      } else {
        loginType = LoginType.ExtendedOtp;
      }
    }

    if (loginType === LoginType.Full || loginType === LoginType.ExtendedOtp || loginType === LoginType.ContactExtendedOtp) {
      thunkAPI.dispatch(setLoginType(loginType));
      thunkAPI.dispatch(getMyInvoices());
    } else {
      thunkAPI.dispatch(goToPage('invoiceLoginRedirect'));
    }
  } catch (error) {
    thunkAPI.dispatch(goToPage('displayInvoicesError'));
    return { invoices: [], error: true };
  }
});


const initialState = {
  page: '',
  loading: true,
  firstLoading: true,
  error: false,
  visibleBlock: true,
  selfCareInvoiceData: {},
  invoicesList: [],
  previousButton: false,
  absolutelyNew: false,
  activeInvoiceURL: '',
  activeInvoiceUrlType: '',
  loginType: '',
  invoiceData: {
    billCycle: '',
  },
};

const invoiceComponentBlockSlice = createSlice({
  name: 'selfCareInvoiceBlock',
  initialState: initialState,
  reducers: {
    goToPage: (state, action) => {
      state.page = action.payload;
    },
    activeInvoiceOnlineIFrame: (state, action) => {
      return { ...state, activeInvoiceURL: action.payload.url, activeInvoiceUrlType: action.payload.type };
    },
    setInvoiceData: (state, action) => {
      state.invoiceData.billCycle = action.payload.billCycle;
    },
    setLoginType: (state, action) => {
      state.loginType = action.payload;
    },
    reportDWH: (state, action) => { },

  },

  extraReducers: {
    [getMyInvoices.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      const { invoices, error } = action.payload;

      let newCustomerCount = lodash.filter(invoices, function (invoice) {
        return invoice.isNewCustomer == true;
      }).length;
      const previousBtnStatus = newCustomerCount == invoices.length || invoices.length == 0 ? false : true;
      const absolutelyNew = newCustomerCount > 0 && newCustomerCount == invoices.length ? true : false;
      const visibleBlock = invoices.length == 1 && invoices[0].invoices.length == 0 && !absolutelyNew ? false : true;
      return {
        ...state,
        visibleBlock: visibleBlock,
        invoicesList: invoices,
        previousButton: previousBtnStatus,
        absolutelyNew: absolutelyNew,
        loading: false,
        error: error,
        firstLoading: false,
      };
    },
  },
});

export const { goToPage, activeInvoiceOnlineIFrame, setInvoiceData, setLoginType, reportDWH } = invoiceComponentBlockSlice.actions;
export default invoiceComponentBlockSlice.reducer;
